export interface IUser {
  active_status: boolean;
  admin?: boolean;
  email: string;
  id: string;
  last_name: string;
  name: string;
  super_admin?: boolean;
  roles: string[]; 
}

export interface ITenant {
    id: string,
    name: string,
    users: IUser[]
    
  }

export function transformToBackendTenant(data: ITenant) {
  return {
    ...data,
    users: data.users.map((user: IUser) => {
      return {
        ...user,
        roles: user.roles.map((role) => {
          let result = role;
          if (role === "Admin") {
            result = "tenant_admin";
          } else if (role === "Write") {
            result = "write";
          } else if (role === "Read") {
            result = "read";
          }
          return result;
        }),
      };
    }),
  };
}

export function transformFromBackendTenant(backendType: ITenant) {
  return {
    ...backendType,
    users: backendType.users.map((user: IUser) => {
      return {
        ...user,
        roles: user.roles.map((role) => {
          let result = role;
          if (role === "tenant_admin") {
            result = "Admin";
          } else if (role === "write") {
            result = "Write";
          } else if (role === "read") {
            result = "Read";
          }
          return result;
        }),
      };
    }),
  };
}